/**
 * Methods for accessing ToDesktop Menu Bar App specfic functionality.
 *
 * @remarks
 * This package exposes a number of methods for accessing ToDesktop Menu Bar App
 * specfic functionality.
 *
 * @experimental
 * @public
 * @packageDocumentation
 */
import { setupAddEventListener, setupRemoveEventListener, } from "@todesktop/client-util";
const _menuBarEventMappings = {
    show: "menubar.show",
    hide: "menubar.hide",
};
/**
 * Enlarges the MenuBar view.
 *
 * @param size - Specifies the width and height to resize to. If not specified
 * the window will be resized to 800x1000.
 * @public
 */
export async function enlarge(size) {
    return window["todesktop"].menubar.enlarge(size);
}
/**
 * Restores the MenuBar app to it's pre-defined size.
 * @public
 */
export async function shrink() {
    return window["todesktop"].menubar.shrink();
}
/**
 * @public
 */
export const addEventListener = setupAddEventListener(_menuBarEventMappings);
/**
 * @public
 */
export const removeEventListener = setupRemoveEventListener(_menuBarEventMappings);
